import { Textarea } from "components/Form/Textarea";
import styled from "styled-components";

export const TemplateTextarea = styled(Textarea)`
  resize: vertical;
  height: 250px;
`;
